// extracted by mini-css-extract-plugin
export default {"wired":"jPDgef","mobile":"JFxXB9","separator":"FeDWnL"};